import ResultLogo from "@components/job_search/search_result_card/result_logo.tsx";
import TitleCompany from "@components/job_search/search_result_card/title_company.tsx";
import Tags from "@components/job_search/search_result_card/tags.tsx";
import Footer from "@components/job_search/search_result_card/footer.tsx";

interface Props {
  id: string;
  title: string;
  company: string;
  logoUrl: string;
  locations?: string[];
  workType?: string | null;
  payRange?: string;
  publishedAt: string;
  url: string;
  external?: boolean;
  loading?: boolean;
  trackClick?: () => void;
  viewed: boolean;
  onView: (id: string) => void;
}

export const SearchResultCard = ({
  id,
  title,
  company,
  logoUrl,
  locations,
  workType,
  payRange,
  publishedAt,
  url,
  external,
  loading,
  trackClick,
  viewed,
  onView,
}: Props) => {
  return (
    <div
      className={`flex flex-col p-6 gap-4 justify-between border-2 rounded-lg border-solid border-gray-00 ${
        viewed ? "bg-[var(--object-fills-grey)]" : "bg-white"
      }`}
      data-provides="search-result"
      data-loading={loading ? "true" : "false"}
    >
      <div className="flex flex-row items-center gap-2">
        <ResultLogo loading={loading} company={company} logoUrl={logoUrl} />
        <div className="flex flex-col">
          <TitleCompany loading={loading} company={company} title={title} />
        </div>
      </div>
      <Tags loading={loading} locations={locations} workType={workType} payRange={payRange} />
      <div className="flex flex-row items-center justify-between">
        <Footer
          loading={loading}
          publishedAt={publishedAt}
          url={url}
          external={external ?? true}
          trackClick={trackClick}
          viewed={viewed}
          onView={() => onView(id)}
        />
      </div>
    </div>
  );
};
